<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
body,
html {
  width: 100%;
  height: 100%;
  background: #f7f8fa;
  font-family: "Microsoft YaHei";
}
* {
  padding: 0px;
  margin: 0px;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.button {
  padding: 0px 15px;
  background-color: #0296e0;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  line-height: 28px;
  cursor: pointer;
  font-size: 14px;
}
.button:hover {
  opacity: 0.5;
}
.buttons {
  padding: 0px 15px;
  background-color: #e2f5ff;
  border-radius: 4px;
  border: solid 1px #0296e0;
  box-sizing: border-box;
  color: #0296e0;
  display: inline-block;
  line-height: 28px;
  cursor: pointer;
  font-size: 14px;
}
.buttons:hover {
  opacity: 0.5;
}
.min_width {
  min-width: 1098px;
}
.pagination-container {
  width: 1128px;
  text-align: right;
  margin: 20px auto 0px;
  padding-bottom: 20px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: #e7e7e9;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue